import { BehaviorContext } from '../../behavior-context';

import { Behavior } from '../../behavior';
import { PgInputFactoryComponent } from 'projects/grit-core/src/lib/pg-field/pg-input-factory/pg-input-factory.component';
import { InputModel } from 'projects/grit-core/src/lib/pg-field/pg-input-factory/input-model';
import { Injectable } from '@angular/core';

const emailRegex = /^(.+)@(.+)\.([0-9a-z]{2,})$/i;

@Injectable()
export class FormatFieldAsEmailOrPhone implements Behavior {
  async execute(
    args: { emailLabel: string; phoneLabel: string; emailOrPhoneLabel: string },
    context: BehaviorContext
  ): Promise<any> {
    const inputFactory = context.target as PgInputFactoryComponent;
    const inputModel: InputModel = inputFactory.inputModel;
    const value: string = inputFactory.input.value;
    args = args || <any>{};
    const getValueType = val => {
      if (emailRegex.test(val)) {
        return 'email';
      } else if (
        value.indexOf('@') === -1 &&
        value.replace(/[^0-9]/g, '').length === 10
      ) {
        return 'phone';
      }
      return 'none';
    };

    const control = inputFactory.parentFormGroup.get(
      inputModel.formControlName
    );

    // EXIT if invalid values passed
    if (!control || !control.value) {
      return;
    }

    const valueType = getValueType(control.value);

    if (valueType === 'phone') {
      const fValue = value.replace(/[^0-9]/g, '');

      control.setValue(
        `${fValue.substr(0, 3)}-${fValue.substr(3, 3)}-${fValue.substr(6, 4)}`
      );

      inputModel.label = args.phoneLabel || 'Mobile phone';
    } else if (valueType === 'email') {
      inputModel.label = args.emailLabel || 'Email';
    } else {
      inputModel.label = args.emailOrPhoneLabel || 'Mobile phone or email';
    }
  }
}
